import {
  Box,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  Button,
  useTheme,
  Flex,
  Text
} from "@chakra-ui/react";
import React, { useState } from "react";
import { TbEdit } from "react-icons/tb";
import { MdOutlineDeleteOutline } from "react-icons/md";
import DeletePopup from "../../popups/DeletePopup";
import { deleteMentor } from "../../../store/slice/teacherManagementSlice";
import { useToastContext } from "../../toastNotificationProvider/ToastNotificationProvider";
import { useDispatch } from "react-redux";

const TeacherManagementTable = ({
  onEdit,
  entityType,
  data = [],
  extraColumns = [],
  limit,
  columnOrder = []
}) => {
  const [isDeletePopupOpen, setDeletePopupOpen] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);

  const theme = useTheme();
  const dispatch = useDispatch();
  const { addNotification } = useToastContext();
  const { editButtonColor, deleteBtnColor } = theme.colors.pallete;

  // pagination setup
  const itemsPerPage = limit || data.length;
  const totalPages = Math.ceil(data.length / itemsPerPage);
  const startIndex = (currentPage - 1) * itemsPerPage;
  const endIndex = startIndex + itemsPerPage;
  const paginatedData = data.slice(startIndex, endIndex);

  // define columns
  const fixedColumns = [
    {
      label: "S.No",
      key: "sno",
      render: (_row, rowIdx) => startIndex + rowIdx + 1
    },
    {
      label: "Teacher Name",
      key: "name",
      render: (row) => row.name || "—"
    },
    { label: "Email", key: "email", render: (row) => row.email || "—" },
    {
      label: "Password",
      key: "password",
      render: (row) => {
        if (!row.password) return "—";
        const len = row.password.length;
        const maxMask = 6;
        const dots = "•".repeat(Math.min(len, maxMask));
        return len > maxMask ? dots + "…" : dots;
      }
    }
  ];

  let allColumns = [...fixedColumns, ...extraColumns];

  // apply custom column order if provided
  if (columnOrder.length) {
    allColumns = columnOrder
      .map((key) => allColumns.find((col) => col.key === key))
      .filter(Boolean);
  }

  const handleDeleteClick = (row) => {
    setSelectedRow(row);
    setDeletePopupOpen(true);
  };

  const handleConfirmDelete = async () => {
    if (!selectedRow) return;
    try {
      await dispatch(deleteMentor(selectedRow.id));
      addNotification(
        `${entityType.charAt(0).toUpperCase() + entityType.slice(1)} deleted successfully`,
        "success",
        3000
      );
    } catch (error) {
      console.error("Error deleting:", error);
    } finally {
      setDeletePopupOpen(false);
    }
  };

  return (
    <Box overflowX="auto" mt={6}>
      <Table variant="unstyled">
        <Thead>
          <Tr>
            {allColumns.map((col) => (
              <Th whiteSpace="nowrap" key={col.key}>
                {col.label}
              </Th>
            ))}
            <Th>Action</Th>
          </Tr>
        </Thead>
        <Tbody>
          {paginatedData.map((row, idx) => (
            <Tr key={row.id || idx} verticalAlign="top">
              {allColumns.map((col) => (
                <Td key={col.key}>
                  {col.render
                    ? col.render(row, idx)
                    : row[col.key] || "—"}
                </Td>
              ))}
              <Td>
                {/* <Button p={0} variant="ghost"  isDisabled color={editButtonColor} onClick={() => onEdit(row)}>
                  <TbEdit size="20px" />
                </Button> */}
                <Button
                  p={0}
                  variant="ghost"
                  color={deleteBtnColor}
                  onClick={() => handleDeleteClick(row)}

                >
                  <MdOutlineDeleteOutline size="20px" />
                </Button>
              </Td>
            </Tr>
          ))}
        </Tbody>
      </Table>

      {/* Pagination Controls */}
      {totalPages > 1 && (
        <Flex justify="center" align="center" m={10} gap={4}>
          <Button size="sm" onClick={() => setCurrentPage((p) => Math.max(p - 1, 1))} isDisabled={currentPage === 1}>
            Prev
          </Button>

          <Text fontSize="sm" fontWeight="medium">
            {currentPage} / {totalPages}
          </Text>

          <Button
            size="sm"
            onClick={() => setCurrentPage((p) => Math.min(p + 1, totalPages))}
            isDisabled={currentPage === totalPages}
          >
            Next
          </Button>
        </Flex>
      )}

      <DeletePopup
        isOpen={isDeletePopupOpen}
        onClose={() => setDeletePopupOpen(false)}
        onDelete={handleConfirmDelete}
        text={`the ${entityType}`}
      />
    </Box>
  );
};

export default TeacherManagementTable;
